// Runtime tracker for Japanese UI strings that appear on screen but have
// no English translation registered in the dictionary. Used only when the
// user is in English mode. Dev-only console warnings; production silently
// records for the /i18n-report page.
const missing = new Map(); // ja -> { count, first_seen, samples: Set<string> }
let subscribers = new Set();

const isDev = () => {
  try {
    return typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production';
  } catch { return false; }
};

export function recordMissing(ja, source) {
  if (!ja || typeof ja !== 'string') return;
  const clean = ja.trim();
  if (!clean) return;
  const cur = missing.get(clean) || { count: 0, first_seen: Date.now(), samples: new Set() };
  cur.count += 1;
  if (source) cur.samples.add(String(source).slice(0, 60));
  missing.set(clean, cur);
  if (isDev() && cur.count === 1) {
    // eslint-disable-next-line no-console
    console.warn('[i18n] missing EN translation for:', clean);
  }
  subscribers.forEach((s) => { try { s(); } catch { /* noop */ } });
}

export function getMissing() {
  const out = [];
  missing.forEach((v, k) => {
    out.push({ ja: k, count: v.count, first_seen: v.first_seen, samples: Array.from(v.samples) });
  });
  out.sort((a, b) => b.count - a.count);
  return out;
}

export function clearMissing() { missing.clear(); subscribers.forEach((s) => { try { s(); } catch { /* noop */ } }); }

export function subscribeMissing(fn) {
  subscribers.add(fn);
  return () => subscribers.delete(fn);
}
